import React from "react";
import clsx from "clsx";

const CustomRadioButton = ({ id, name, checked, label, value, onChange }) => {
  return (
    <label
      htmlFor={id}
      className={clsx(
        "inline-flex items-center gap-2.5 h-10 px-4 mobile:px-3 rounded-full border cursor-pointer text-[13px] font-medium text-nowrap transition-all duration-200",
        checked
          ? "border-indigo-400/50 bg-active-background text-text-primary"
          : "border-edge text-light-gray hover:border-indigo-400/40 hover:text-text-primary"
      )}
    >
      <input
        type="radio"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        className="sr-only"
        value={value}
      />
      <span
        className={clsx(
          "h-4 w-4 rounded-full border flex items-center justify-center shrink-0 transition-colors duration-200",
          checked ? "border-accent" : "border-edge-strong"
        )}
      >
        {checked ? (
          <span className="h-2 w-2 rounded-full bg-gradient-to-r from-accent to-accent-bright" />
        ) : null}
      </span>
      {label}
    </label>
  );
};

export default CustomRadioButton;
